module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen-layout"
  }, [_c('div', {
    staticClass: "no-print"
  }, [_vm._t("header", [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "flat": "",
      "dark": "",
      "dense": "",
      "xxstyle": "z-index:8;position:fixed;"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.rightColumnActive = !_vm.rightColumnActive
      }
    }
  })], 1)])], 2), _vm._v(" "), _c('div', {
    staticClass: "page-area",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.leftVisible) ? _c('div', {
    staticClass: "column left-column no-print",
    class: {
      'active': _vm.leftColumnActive, 'wider': _vm.leftWider, 'uniform': _vm.uniformColour
    }
  }, [_vm._t("left", [_vm._v("\n                Left slot "), _vm._l((20), function(n) {
    return _c('span', [_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!")])
  }), _vm._v(" End left slot\n            ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "middleColumn",
    staticClass: "column middle-column",
    attrs: {
      "id": "middle-column"
    }
  }, [_vm._t("default", [_vm._v("\n                Default slot "), _vm._l((30), function(n) {
    return _c('span', [_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!")])
  }), _vm._v(" End default slot                \n            ")])], 2), _vm._v(" "), (_vm.rightVisible) ? _c('div', {
    staticClass: "column right-column no-print",
    class: {
      'active': _vm.rightColumnActive, 'uniform': _vm.uniformColour
    }
  }, [_vm._t("right", [_vm._v("\n                Right slot "), _vm._l((20), function(n) {
    return _c('span', [_vm._v("Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio repellat, doloremque, delectus dolores veritatis iste excepturi quasi voluptate aspernatur sed doloribus aliquam sit unde dolor velit saepe aperiam? Consequatur, veritatis!")])
  }), _vm._v(" End right slot\n            ")])], 2) : _vm._e(), _vm._v(" "), (_vm.leftButtonVisible) ? _c('div', {
    staticClass: "expander left-expander clickable no-print",
    class: {
      'active': _vm.leftColumnActive
    },
    on: {
      "click": _vm.expandLeft
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_right")])], 1) : _vm._e(), _vm._v(" "), (_vm.rightButtonVisible) ? _c('div', {
    staticClass: "expander clickable right-expander no-print",
    class: {
      'active': _vm.rightColumnActive
    },
    on: {
      "click": _vm.expandRight
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), _vm._v(" "), (_vm.leftColumnActive) ? _c('div', {
    staticClass: "overlay left-overlay",
    on: {
      "click": _vm.overlayClicked
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rightColumnActive) ? _c('div', {
    staticClass: "overlay right-overlay",
    on: {
      "click": _vm.overlayClicked
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ee1efbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ScreenLayout.vue
// module id = 2497
// module chunks = 1